import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Associates,
  GetSummaryAssociates,
  GetOrderAssociates,
  DeleteAssociates,
  CreateAssociates,
  UpdateAssociates,
  CheckCpfCustomer,
} from '../../../store/actions';
import { APIClient } from '../helpers/helpersInjection';
import { useLoading } from './hooksInjection';
import { notifyError } from './componentsInjection';

/**
 * AssociatesInjection is responsible for injecting the methods about store of associates.
 *
 * @return
 *  associates: Array of associates.
 *  get: () => Void
 *  create: () => void
 *  update: () => void
 *  delete: () => void
 */
export const AssociatesInjection = () => {
  const [reqStatus, setReqStatus] = useState(false);
  const [proposalsAssociates, setProposalsAssociates] = useState([]);

  const api = new APIClient();
  const dispatch = useDispatch();
  const { setLoading } = useLoading();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getAssociates = async (params) => {
    dispatch(Associates(params));
  };

  const checkCpf = async (cpf) => {
    dispatch(CheckCpfCustomer(cpf));
  };

  const getSummaryAssociates = async () => {
    dispatch(GetSummaryAssociates());
  };

  const getOrderAssociates = async (params) => {
    dispatch(GetOrderAssociates(params));
  };

  /**
   * @return Void
   */
  const deleteAssociate = (id) => {
    dispatch(DeleteAssociates(id));
  };

  const createAssociate = (values, goToProposal, history) => {
    dispatch(CreateAssociates(values, goToProposal, history));
  };

  const updateAssociate = (id, values, history) => {
    dispatch(UpdateAssociates(id, values, history));
  };

  const requestGetProposalsAssociates = useCallback(
    async (hash, toggle, shouldSetLoadingScreen = false) => {
      setReqStatus(true);
      shouldSetLoadingScreen && setLoading(true);

      await api
        .get(`/proposal?customer=${hash}`)
        .then((res) => {
          setProposalsAssociates(res.data);
          if (typeof toggle === 'function') {
            toggle();
          }
        })
        .catch((err) => {
          console.error('Erro ao buscar propostas:', err);
          notifyError('Erro ao buscar propostas');
        })
        .finally(() => {
          shouldSetLoadingScreen && setLoading(false);
          setReqStatus(false);
        });
    },
    []
  );

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * user: object
   */
  const {
    error,
    loading,
    associates,
    success,
    total,
    active,
    inactive,
    today,
  } = useSelector((state) => ({
    error: state.Associates.error,
    loading: state.Associates.loading,
    associates: state.Associates.associates,
    success: state.Associates.success,
    total: state.Associates.total,
    active: state.Associates.active,
    inactive: state.Associates.inactive,
    today: state.Associates.today,
  }));

  return {
    createAssociate,
    updateAssociate,
    getAssociates,
    deleteAssociate,
    getOrderAssociates,
    getSummaryAssociates,
    checkCpf,
    error,
    loading,
    associates,
    success,
    proposalsAssociates,
    total,
    active,
    inactive,
    today,
    requestGetProposalsAssociates,
    reqStatus,
  };
};
